import { type Components } from '@mui/material';

import { type HorizonTheme } from './horizon-theme';

export const muiIconButton: Components<HorizonTheme>['MuiIconButton'] = {
  defaultProps: {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
  },

  styleOverrides: {
    root: {
      '&.Mui-focused': {
        outline: 'none',
      },
    },
  },
};
